export default function setCurrency ($currencySetters) {
	let route = window.projectConfig.route.ajax.currencies;
	let setCurrency = (route, currency) => {
		return $.ajax({
			url: route,
			type: 'POST',
			dataType: 'JSON',
			data: {
				param: currency
			}
		})
			.done((response) => {
				if (response.success) {
					window.location.reload();
				}

				if (!response.success) {
					if (response.message) {
						window.Noty.error(response.message);
					} else {
						window.Noty.error('Currency Setting Error ');
					}
				}
			})
			.fail((err) => {
				console.warn(err);
			})
			.always(() => {});
	};

	$currencySetters.each((i, root) => {
		let $root = $(root);
		let $currency = $root.find('[data-currency]');

		$currency.on('click', (e) => {
			e.preventDefault();

			let $this = $(e.currentTarget);
			let currentCurrency = $this.data('currency');

			setCurrency(route, currentCurrency);
		});
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/setCurrency.js